import { render, staticRenderFns } from "./RoleTemplate.tab.vue?vue&type=template&id=a6bbf678&"
import script from "./RoleTemplate.tab.vue?vue&type=script&lang=ts&"
export * from "./RoleTemplate.tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports